import PropTypes from 'prop-types';

import { SharedZoneBlocks, SharedZoneCustomSlug } from 'store/SharedZone/blocks/selectors';
import SubscribeFormWidgetLayout from 'components/SubscribeFormWidgetLayout';

const mapStateToProps = (state) => ({
  ...SharedZoneCustomSlug.getWidgetData(state),
  isSingleBlock: true,
});

const SubscribeFormWidget = SharedZoneBlocks.connect(mapStateToProps)(SubscribeFormWidgetLayout);

SubscribeFormWidget.propTypes = {
  /** passed from redux */
  id: PropTypes.string, // required for unification 2 or more form on 1 page
  backgroundUrl: PropTypes.string,
  initData: PropTypes.shape({
    isColumn: PropTypes.bool,
    heading: PropTypes.string,
    headingTagName: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
    buttonText: PropTypes.string,
    agreementTextTemplate: PropTypes.string,
    markup: PropTypes.any,
  }),
  successData: PropTypes.shape({
    isColumn: PropTypes.bool,
    heading: PropTypes.string,
    headingTagName: PropTypes.string,
    description: PropTypes.string,
    markup: PropTypes.any,
    redirectUrl: PropTypes.string,
    openInNewTab: PropTypes.bool,
    buttonText: PropTypes.string,
  }),
};

export default SubscribeFormWidget;
